// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".location-map{display:flex;height:440px;min-height:440px;width:100%;order:4;flex:1;position:relative}@media(min-width:900px){.location-map{width:unset;order:unset;height:692px;order:2;max-width:50%}}.location-map #map{top:0!important;height:100%!important;min-height:unset!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
